export default __webpack_public_path__ + "static/hero-image-2-ecdb982a281ef6819b01198c1109660d.jpeg";